export default __webpack_public_path__ + "static/media/ax.467da519.svg";